module.exports = __webpack_public_path__ + "static/media/costIcon.edbeba6f.svg";